module.exports = __webpack_public_path__ + "img/solution.5c3fc8e4.svg";